var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Scoreboard = /** @class */ (function (_super) {
    __extends(Scoreboard, _super);
    function Scoreboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Scoreboard.prototype.render = function () {
        var _a = this.props, team1 = _a.team1, team2 = _a.team2, endingPoint1 = _a.endingPoint1, endingPoint2 = _a.endingPoint2, classNames = _a.classNames;
        return (React.createElement("div", { className: "rj-ev-list__scoreboard" + (classNames ? " rj-ev-list__scoreboard--" + classNames : ""), "data-uat": "div-ev-list-scoreboard" },
            React.createElement("div", { className: "rj-ev-list__scoreboard__player", "data-uat": "div-ev-list-scoreboard-player" },
                team1.map(function (item, index) { return (React.createElement("div", { key: index, className: "rj-ev-list__scoreboard__info", "data-uat": "div-ev-list-scoreboard-info" }, item)); }),
                endingPoint1 && React.createElement("div", { className: "rj-ev-list__scoreboard__info-total", "data-uat": "div-ev-list-scoreboard-info-total" }, endingPoint1)),
            React.createElement("div", { className: "rj-ev-list__scoreboard__player", "data-uat": "div-ev-list-scoreboard-player" },
                team2.map(function (item, index) { return (React.createElement("div", { key: index, className: "rj-ev-list__scoreboard__info", "data-uat": "div-ev-list-scoreboard-info" }, item)); }),
                endingPoint2 && React.createElement("div", { className: "rj-ev-list__scoreboard__info-total", "data-uat": "div-ev-list-scoreboard-info-total" }, endingPoint2))));
    };
    return Scoreboard;
}(React.PureComponent));
export { Scoreboard };
//# sourceMappingURL=Scoreboard.js.map